/**
 * Mensagens de erro do import por chave i18n na língua do painel (M1: fatiado
 * de ReviewPanel.tsx pelo limite de linhas). Os 422 de moeda/idioma mapeados;
 * qualquer outro erro cai na mensagem original do servidor.
 * O CURRENCY_CONFIRMATION_REQUIRED do commit NÃO passa por aqui: reabre a
 * faixa do cartão com role="alert" (ReviewPanel.tsx).
 *
 * #486 (item 2): erros com chave i18n própria aparecem INLINE no cartão de
 * onde vieram (role="alert"), não só em toast — leitor de voz sabe onde
 * resolver sem adivinhar porque «Importar» não avança.
 */
type Translate = (key: string, vars?: Record<string, string>) => string

/** 422 com texto próprio no glossário — anunciar inline no cartão */
const KEYED_ERROR_CODES: ReadonlySet<string> = new Set([
  'CURRENCY_NOT_RESTAURANT',
  'CURRENCY_INVALID',
  'LOCALE_CONFIRMATION_REQUIRED',
])

/** true = erro com chave i18n (#486: vai INLINE para o cartão, com foco) */
export function isKeyedImportError(e: unknown): boolean {
  return KEYED_ERROR_CODES.has((e as { code?: string }).code ?? '')
}

export function importErrorMessageFor(
  t: Translate,
  restaurantCurrency: string | null | undefined,
  e: unknown,
): string {
  const code = (e as { code?: string }).code
  if (code === 'CURRENCY_NOT_RESTAURANT')
    return t('admin.import.error_currency_not_restaurant', {
      restaurant: restaurantCurrency ?? '',
    })
  if (code === 'CURRENCY_INVALID') return t('admin.import.error_currency_invalid')
  if (code === 'LOCALE_CONFIRMATION_REQUIRED') return t('admin.import.error_locale_confirmation')
  return (e as Error).message
}
